import React, { useEffect, useState } from "react";
import { client } from "../../sanityClient";

export default function DailyMoneyCard() {
    const [data, setData] = useState({ debit: 0, credit: 0, net: 0 });

    useEffect(() => {
        const today = new Date();
        const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);

        client
            .fetch(
                `*[_type == "moneyTransaction" && date >= $start && date < $end]{
          givenOrTaken, amount
        }`,
                { start: startOfDay.toISOString(), end: endOfDay.toISOString() }
            )
            .then((items) => {
                let debit = 0, credit = 0;
                items.forEach((t) => {
                    if (t.givenOrTaken === "Debit") debit += +t.amount;
                    else credit += +t.amount;
                });
                setData({ debit, credit, net: credit - debit });
            });
    }, []);

    return (
        <div className="summary-card-grid">
            <div className="summary-card-item">
                <span className="summary-card-label">Debit</span>
                <span className="summary-card-value text-danger">₹{data.debit.toLocaleString()}</span>
            </div>
            <div className="summary-card-item">
                <span className="summary-card-label">Credit</span>
                <span className="summary-card-value text-success">₹{data.credit.toLocaleString()}</span>
            </div>
            <div className="summary-card-item">
                <span className="summary-card-label">Net</span>
                <span className={`summary-card-value ${data.net >= 0 ? "text-success" : "text-danger"}`}>
                    ₹{Math.abs(data.net).toLocaleString()}
                </span>
            </div>
        </div>
    );
}